import { lazy } from "react";
import type { RouteObject } from "react-router";
import RootLayout from "./RootLayout";

// Lazy load routes
const ProofingHomePage = lazy(() =>
  import("./domain/proofing-flow/page").then((module) => ({ default: module.ProofingHomePage })),
);

const DocumentReviewPage = lazy(() => import("./domain/proofing-flow/document-review/page"));
const DocumentComparisonPage = lazy(
  () => import("./domain/proofing-flow/document-comparison/page"),
);

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <ProofingHomePage />,
      },
      {
        path: "title/:titleId/round/:roundId/document/:documentId/review",
        element: <DocumentReviewPage />,
      },
      {
        path: "title1/:titleId1/round1/:roundId1/document1/:documentId1/title2/:titleId2/round2/:roundId2/document2/:documentId2/comparison",
        element: <DocumentComparisonPage />,
      },
    ],
  },
];
